import {
  ACTIVATE_LOCALIZATION,
  ACTIVATE_LOCALIZATION_SUCCESS,
  ACTIVATE_LOCALIZATION_ERROR,
  DEACTIVATE_LOCALIZATION,
} from '../actions/types';

//todo paginate this
const DEFAULT_STATE = {
  data: null,
  loading: false,
  saving: false,
  error: null
}

export default function(state = DEFAULT_STATE, action){
  // console.log('action received: ', action);
  switch(action.type){
    case ACTIVATE_LOCALIZATION:
      return {
        ...state,
        data: null,
        loading: true,
        error: null,
      }
    break;
    case ACTIVATE_LOCALIZATION_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      }
    break;
    case ACTIVATE_LOCALIZATION_ERROR:
      return {
        ...state,
        data: null,
        loading: false,
        error: action.payload
      }
    break;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/activeLocalizationReducer.js